<label
  class="radio-button"
  [class.radio-button--disabled]="disabled"
  [class.radio-button--error]="error"
  data-test="radio-label"
  [class.radio-button--label-less]="!label"
>
  <input
    class="radio-button__input"
    type="radio"
    [disabled]="disabled"
    [name]="name"
    [value]="htmlValue"
    (change)="writeValue(htmlValue)"
    data-test="radio-input"
  />
  <app-icon class="radio-button__icon" [name]="iconName"></app-icon>
  {{ label }}
</label>
